import { render, staticRenderFns } from "./Card1.vue?vue&type=template&id=6b1929ef&"
import script from "./Card1.vue?vue&type=script&lang=js&"
export * from "./Card1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports